import React from "react";

// Función para formatear el número con 17 enteros y 6 decimales
export const formatQRTotal = (total) => {
  const formattedNumber = Number(total).toFixed(6);
  const [integerPart, decimalPart] = formattedNumber.split(".");
  const formattedInteger = integerPart.padStart(17, "0");
  return `${formattedInteger}.${decimalPart}`;
};

const RoundQRDecimals = ({ total }) => {
  const finalFormatted = formatQRTotal(total);
  return <span>{finalFormatted}</span>;
};

export default RoundQRDecimals;
